import React from 'react'

export const CardLayout: React.FC = ({ children }) => {
  return (
    <div className="card-layout">
      <div className="card-layout-box">{children}</div>
    </div>
  )
}
